import { ChangeDetectionStrategy, Component, Input, TemplateRef, ViewChild } from '@angular/core';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';

import { EventType } from '../../util';

/**
 * <p>
 *   Tooltip can be appended to the triggering element's parent or to the body.
 *   When we want to append it to the body we should set the <b>container</b> property to <b>"body"</b>.
 * </p>
 * <p>
 *   By default, tooltip has <b>max-width</b> set to <b>200px</b>.
 *   In case when there is a need tooltip to have an auto width we should do the following:
 * </p>
 * <ul>
 *   <li>default tooltip template: set property <b>autoWidth</b> to <b>"true"</>.</li>
 *   <li>custom tooltip template: set property <b>tooltipClass</b> to <b>"tooltip-auto-width"</b> on the element where
 *   tooltip is defined.</li>
 * </ul>
 */
@Component({
  selector: 'pcs-tooltip',
  templateUrl: './tooltip.component.html',
  styleUrls: ['./tooltip.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TooltipComponent {

  @Input() title = '';
  @Input() trigger = EventType.Hover;
  @Input() tabIndex;
  @Input() icon = '';
  @Input() container = '';
  @Input() templateRef: TemplateRef<any>;
  @Input() disabled;
  @Input() autoWidth = false;

  @ViewChild(NgbTooltip, {static: true}) tooltip: NgbTooltip;
  @ViewChild('tipContent', {static: true}) tipContent;

  customTooltipClass() {
    return this.autoWidth ? 'tooltip-auto-width' : '';
  }
}
